import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#0A281E] text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <p className="font-serif text-xl font-semibold">Professor Carlo Enrico Traverso</p>
            <p className="mt-2 text-xs uppercase tracking-[0.22em] text-[#E8F1EC]/50">
              Oftalmologia e Chirurgia Oculare
            </p>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Attività specialistica e chirurgica a Genova e Savona presso Casa della Salute.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.linkedin.com/in/carlo-enrico-traverso-400174a/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-linkedin"
                aria-label="LinkedIn – Professor Carlo Enrico Traverso"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-[#E8F1EC] hover:text-white"
              >
                <Linkedin size={17} />
              </a>
              <a
                href="https://www.instagram.com/professor_traverso_oculista_md/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                aria-label="Instagram – Professor Carlo Enrico Traverso"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-[#E8F1EC] hover:text-white"
              >
                <Instagram size={17} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61572806454159"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                aria-label="Facebook – Professor Carlo Enrico Traverso"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-[#E8F1EC] hover:text-white"
              >
                <Facebook size={17} />
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E8F1EC]/50">Navigazione</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="text-white/70 transition-colors duration-300 hover:text-white">Home</Link></li>
              <li><Link data-testid="footer-link-about" to="/chi-sono" className="text-white/70 transition-colors duration-300 hover:text-white">Chi sono</Link></li>
              <li><Link data-testid="footer-link-services" to="/di-cosa-mi-occupo" className="text-white/70 transition-colors duration-300 hover:text-white">Di cosa mi occupo</Link></li>
              <li><Link data-testid="footer-link-evaluation" to="/richiedi-una-valutazione" className="text-white/70 transition-colors duration-300 hover:text-white">Richiedi una valutazione</Link></li>
              <li><Link data-testid="footer-link-media" to="/media" className="text-white/70 transition-colors duration-300 hover:text-white">Media</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contatti" className="text-white/70 transition-colors duration-300 hover:text-white">Contatti</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E8F1EC]/50">Contatti</p>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 text-[#2E6B50]" />
                <span>Largo XII Ottobre 62, 16121 Genova<br />Corso Agostino Ricci 203R, 17100 Savona</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="shrink-0 text-[#2E6B50]" />
                <a href="tel:+390109641083" data-testid="footer-phone" className="transition-colors duration-300 hover:text-white">010 9641083</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="shrink-0 text-[#2E6B50]" />
                <a href="mailto:servizioclienti@cds.it" data-testid="footer-email" className="transition-colors duration-300 hover:text-white">servizioclienti@cds.it</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-legal-info">© {new Date().getFullYear()} Professor Carlo Enrico Traverso – Tutti i diritti riservati.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" data-testid="footer-link-privacy" className="transition-colors duration-300 hover:text-white/70">
              Privacy Policy
            </Link>
            <Link to="/cookie-policy" data-testid="footer-link-cookie" className="transition-colors duration-300 hover:text-white/70">
              Cookie Policy
            </Link>
          </div>
          <p>Medico Chirurgo – Specialista in Oftalmologia · Genova / Savona</p>
        </div>

        <div data-testid="footer-credits" className="mt-8 flex items-center justify-center gap-2 border-t border-white/5 pt-6 text-[11px] text-white/35">
          <span>Sito prodotto da</span>
          <img
            src="/images/medpartner-symbol.png"
            alt="Simbolo MedPartner"
            data-testid="footer-credits-logo"
            className="h-4 w-auto opacity-80"
          />
          <span className="font-medium text-white/55">MedPartner S.r.l.</span>
          <span aria-hidden="true">·</span>
          <a
            href="mailto:info@medpartner.it"
            data-testid="footer-credits-email"
            className="transition-colors duration-300 hover:text-white/70"
          >
            info@medpartner.it
          </a>
        </div>
      </div>
    </footer>
  );
};
